import { styled, keyframes } from '@mui/system';
import { Button } from '@mui/material';

const blink = keyframes`
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
`;

export const CardsContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'isLoading'
})(({ theme, isLoading }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  [theme.breakpoints.up('md')]: {
    padding: 0
  },
  [theme.breakpoints.down('md')]: {
    margin: 0,
    padding: 0,
    paddingTop: theme.spacing(1)
  },
  ...(isLoading && {
    filter: 'blur(7px)',
    animation: `${blink} 1.5s alternate infinite linear`
  })
}));

export const ApplianceFilterButtonContainer = styled('div')(({ theme }) => ({
  position: 'sticky',
  display: 'grid',
  gridTemplateAreas: '"filter addWarehouseBtn siteManagerBtn addApplianceBtn"',
  gridTemplateColumns: 'auto 125px 170px 160px',
  gridGap: theme.spacing(1),
  padding: theme.spacing(2, 4, 2, 4),
  width: '100%',
  backgroundColor: '#EEE',
  zIndex: 1100,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 2, 1)
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateAreas: '"addWarehouseBtn siteManagerBtn addApplianceBtn" "filter filter filter"',
    gridTemplateColumns: 'auto',
    padding: theme.spacing(3, 1, 2, 1)
  }
}));

export const SiteManagerButton = styled(Button)({
  gridArea: 'siteManagerBtn'
});

export const AddApplianceButton = styled(Button)({
  gridArea: 'addApplianceBtn'
});

export const AppliancesContainer = styled('div')({
  paddingBottom: '72px'
});
